export default __webpack_public_path__ + "static/12-d037ac087655902fbab29220fab3ce62.jpg";